import {get, map} from 'lodash';

const getModalState = state => state.modal;
const getById = state => getModalState(state).byId;
const getIdList = state => getModalState(state).idList;

const getModalCount = state => getIdList(state).length;
export const isModalDisplayed = state => Boolean(getModalCount(state));

export const getModal = (state, id) => getById(state)[id];
export const getModalMeta = (state, id) => get(getModal(state, id), 'meta', {});

export const getModals = state => {
  const byId = getById(state);
  const idList = getIdList(state);
  return map(idList, id => byId[id]);
};
